export const DEFAULT_CONTENT_ALERT_TIMEZONE = 'America/New_York';

export interface ContentAlertSubscription {
  analystId: number;
  siteId: string;
  subscribed: boolean;
  updatedAt: string;
}

export interface ContentAlertPreference {
  analystId: number;
  dailyDigest: boolean;
  weeklyDigest: boolean;
  timezone: string;
  updatedAt: Date;
}

export interface ContentAlertPreferenceResponse {
  dailyDigest: boolean;
  weeklyDigest: boolean;
  timezone: string;
}

export interface UpdateContentAlertPreferenceRequest {
  dailyDigest?: boolean;
  weeklyDigest?: boolean;
  timezone?: string;
}

export interface ContentAlertSettingsResponse {
  subscribed: boolean;
  dailyDigest: boolean;
  weeklyDigest: boolean;
  timezone: string;
  siteId: string;
}

export interface UpdateContentAlertSettingsRequest {
  subscribed?: boolean;
  dailyDigest?: boolean;
  weeklyDigest?: boolean;
  timezone?: string;
}
